import styled from 'styled-components';

export const Heading = styled.div`
  padding: 0;
  margin: 0;
  font-size: 2rem;
  width: 100%;
`;
